export type IConfirmUserAction = (
  type: 'warning' | 'notice' | 'question',
  title: string,
  body: string,
  callbackFn?: () => any,
  autoRejectAfter?: number
) => JQuery.Deferred<void>;

export function confirmUserAction(
  type: 'warning' | 'notice' | 'question',
  title: string,
  body: string,
  callbackFn?: () => any,
  autoRejectAfter?: number
): JQuery.Deferred<void> {
  const deferred = new ($ as any).Deferred();
  const $modal = $('#confirm-action-modal');
  // Modal Elements
  const $confirmActionModalTitle = $('#confirm-action-modal-title');
  const $modalDialog = $modal.find('.modal-dialog');
  const $modalHeader = $modal.find('.modal-header');
  const $modalTitle = $modal.find('.modal-custom-title');
  const $modalIcon = $modal.find(`.fa.hide.${type}`);
  const $modalBody = $modal.find('.modal-custom-body');
  const $modalCancleBtn = $modal.find('.cancel');
  const $modalConfirmBtn = $modal.find(`.btn-ok.${type}`);

  $modalTitle.empty();
  $modalBody.empty();

  // Display correct modal elements
  $modalHeader
    .removeClass()
    .addClass(type)
    .addClass('modal-header');
  $modalIcon
    .removeClass('hide')
    .siblings('.fa')
    .addClass('hide');
  $modalConfirmBtn
    .removeClass('hide')
    .attr('aria-hidden', 'false')
    .siblings('.btn')
    .not('.cancel')
    .addClass('hide')
    .attr('aria-hidden', 'true');

  // Pass info from function into the modal
  $modalTitle.html(title);
  $confirmActionModalTitle.html(title);

  if (body === '' || typeof body === 'undefined') {
    $modalBody.html('Êtes-vous sûr?');
  } else {
    $modalBody.html(body);
  }
  // If user clicks on, reslove the promsise and allow code execution
  $modalConfirmBtn.off('click').on('click', () => {
    deferred.resolve();
    if (typeof callbackFn === 'function') {
      callbackFn();
    }
    $modal.modal('hide');
  });

  $modalCancleBtn.off('click').on('click', () => {
    deferred.reject();
  });
  // If modal is hidden w/o user OK click, reject promise
  $modal.off('hidden.bs.modal').on('hidden.bs.modal', () => {
    deferred.reject();
  });

  $modal.modal('show');
  $modalDialog.focus();

  if (autoRejectAfter && typeof autoRejectAfter === 'number') {
    setTimeout(() => {
      deferred.reject();
      $modal.modal('hide');
    }, autoRejectAfter);
  }
  // Return promise
  return deferred.promise();
}
